// extracted by mini-css-extract-plugin
export default {"copy-icon":"CopyBtn_copy-icon__Fi4zS","copy-icon-one":"CopyBtn_copy-icon-one__RTnMC","copy-message":"CopyBtn_copy-message__fcKd+","fade-out":"CopyBtn_fade-out__FIGXu"};